import {
  CreateReportRequest,
  CreateReportSuccess,
  CreateReportFailure,
} from './reports.actions'
import { ReportsService } from './reports.service'
import { ShowSnackbar } from '@shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as Reports from './reports.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { downloadBlob } from '@shared/shared.utils'

@Injectable()
export class ReportsEffects {
  constructor(
    private actions: Actions,
    private reportsService: ReportsService,
    private router: Router,
  ) {}

  CreateReport$ = createEffect(() =>
    this.actions.pipe(
      ofType(Reports.CREATE_REPORT_REQUEST),
      switchMap((action: CreateReportRequest) => {
        return this.reportsService.createReport(action.payload).pipe(
          map((result) => {
            return new CreateReportSuccess(result, action.payload)
          }),
          catchError((err, caught) => {
            return of(new CreateReportFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  SaveReport$ = createEffect(
    () =>
      this.actions.pipe(
        ofType<CreateReportSuccess>(Reports.CREATE_REPORT_SUCCESS),
        tap((action) => downloadBlob(action.blob)),
      ),
    { dispatch: false },
  )
}
